import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRouteModel } from '@modules/common/models/activated-route-model';
import { RouteModelService } from '@modules/common/services/route-model.service';

@Injectable({
    providedIn: 'root'
})
export class CurrentRouteService {
    constructor(
        private _router: Router,
        private _routeModelService: RouteModelService
    ) { }

    public getCurrentRoute(): ActivatedRouteModel {
        return this._routeModelService.getRouteModel(this._router.routerState.snapshot.root);
    }
}
